//src/theme/components.js
import { colors } from './colors';
import { spacing } from './spacing';

export const components = {
  // Input
  MuiTextField: {
    styleOverrides: {
      root: {
        '& .MuiOutlinedInput-root': {
          // height: '40px',
          height: 'auto',
        },
      },
    },
  },

  // Radio
  MuiRadio: {
    styleOverrides: {
      root: {
        padding: spacing.sm,
        width: '24px',
        height: '24px',
      },
    },
  },

  // Snackbar
  MuiAlert: {
    styleOverrides: {
      root: {
        borderRadius: '4px',
      },
      icon: {
        marginRight: spacing.md,
      },
    },
  },

  // Chip (per Tag)
  MuiChip: {
    styleOverrides: {
      root: {
        height: '32px',
        borderRadius: '4px',
      },
      label: {
        padding: `0 ${spacing.md}px`,
      },
    },
  },

  // Switch (per Toggle)
  MuiSwitch: {
    styleOverrides: {
      root: {
        width: 42,
        height: 26,
        padding: 0,
        '& .MuiSwitch-switchBase': {
          padding: 0,
          margin: 2,
          transitionDuration: '300ms',
          '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
              backgroundColor: colors.primary.main,
              opacity: 1,
              border: 0,
            },
          },
        },
        '& .MuiSwitch-thumb': {
          boxSizing: 'border-box',
          width: 22,
          height: 22,
        },
        '& .MuiSwitch-track': {
          borderRadius: 26 / 2,
          backgroundColor: colors.grey.light,
          opacity: 1,
        },
      },
    },
  },

  // Altri componenti esistenti...
  MuiButton: {
    styleOverrides: {
      root: {
        textTransform: 'none',
        borderRadius: 4,
        padding: '8px 16px',
      },
      contained: {
        boxShadow: 'none',
        '&:hover': {
          boxShadow: 'none',
        },
      },
    },
    variants: [
      {
        props: { variant: 'warning' },
        style: {
          backgroundColor: colors.warning.main,
          color: '#ffffff',
          '&:hover': {
            backgroundColor: colors.warning.light,
          },
        },
      },
    ],
  },
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: 8,
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
      },
    },
  },
  MuiAppBar: {
    styleOverrides: {
      root: {
        boxShadow: 'none',
      },
    },
  },
  MuiDrawer: {
    styleOverrides: {
      paper: {
        backgroundColor: colors.primary.main,
        color: '#ffffff',
      },
    },
  },
};